import { LitElement, html, css } from "lit";

export class SkioPrepaidGift extends LitElement {
  static properties = {
    key: { type: String },
    isPrepaidSelected: { type: Boolean },
    isPrepaidGift: { type: Boolean },

    email: { state: true },
    message: { state: true },
  }

  static styles = css`
    :host {
      display: block;
      width: 100%;
      margin-top: 1rem;
    }

    .skio-gift-prepaid {
      padding: 5px 10px;
      order: 3;
      display: flex;
      flex-direction: column;
    }

    .skio-prepaid-topline {
      display: flex;
      gap: 10px;
      align-items: center;

      color: #283645;
      font-size: 16px;
      letter-spacing: 0;
    }

    .skio-gift-prepaid-content {
      transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      max-height: 0;
      opacity: 0;

      display: flex;
      flex-direction: column;
    }

    .skio-prepaid-input {
      position: relative;
      margin-top: 1.5rem;
    }

    .skio-prepaid-input label {
      font-family: Protrakt,Open Sans,arial,sans-serif;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: .8px;
      padding: 0 5px;
      text-transform: uppercase;
      position: absolute;
      top: -0.4rem;
      background: white;
      left: 0.5rem;
      white-space: nowrap;
      width: auto;
      color: #283645;
    }

    .skio-prepaid-input textarea, .skio-prepaid-input input {
      padding: 14px 30px 14px 10px;
      width: 100%;

      font-family: inherit;
      letter-spacing: inherit;
      box-sizing: border-box;
    }

    .skio-prepaid-input textarea:focus, .skio-prepaid-input input:focus {
      border-color: #283645;
    }

    .skio-gift-prepaid-content.open {
      max-height: 300px;
      opacity: 1;
    }

    /* The switch - the box around the slider */
    .skio-prepaid-switch {
      position: relative;
      display: inline-block;
      width: 36px;
      height: 20px;
    }

    /* The slider */
    .skio-prepaid-slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: .2s;
      transition: .2s;
      border-radius: 34px;
    }

    .skio-prepaid-slider:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 2px;
      bottom: 2px;
      background-color: white;
      -webkit-transition: .2s;
      transition: .2s;
      border-radius: 50%;
    }

    .skio-prepaid-switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .skio-prepaid-switch input:checked + .skio-prepaid-slider {
      background-color: #283645;
    }

    .skio-prepaid-switch input:focus + .skio-prepaid-slider {
      box-shadow: 0 0 1px #283645;
    }

    .skio-prepaid-switch input:checked + .skio-prepaid-slider:before {
      -webkit-transform: translateX(16px);
      -ms-transform: translateX(16px);
      transform: translateX(16px);
    }
  `

  constructor() {
    super();

    this.isPrepaidSelected = false;
    this.isPrepaidGift = false;

    this.key = '';

    this.email = '';
    this.message = '';

    this.planPicker = null;
  }

  connectedCallback() {
    super.connectedCallback();
    
    this.planPicker = document.querySelector(`skio-plan-picker[key="${this.key}"]`)

    if(!this.planPicker) return;

    this.isPrepaidSelected = this.planPicker.selectedSellingPlanGroup?.name === 'Prepaid';

    this.planPicker.addEventListener('skio::update-selling-plan', (e) => {
      this.isPrepaidSelected = e.detail.isPrepaid;
    })
  }

  updated = (changed) => {
    this.updateForm();
  }

  updateForm() {
    const $email = this.querySelector('input[name="properties[_prepaidGiftEmail]"]')
    const $message = this.querySelector('input[name="properties[_prepaidGiftMessage]"]')

    if(!$email || !$message) return;

    $email.value = this.email;
    $message.value = this.message;

    $email.disabled = !this.isPrepaidGift || !this.isPrepaidSelected;
    $message.disabled = !this.isPrepaidGift || !this.isPrepaidSelected;
  }

  render() {
    if(!this.isPrepaidSelected) return;

    return html`
       <div class="skio-gift-prepaid">
        <div class="skio-prepaid-topline">
          <label class="skio-prepaid-switch">
            <input type="checkbox" name="is-prepaid-gift" .checked="${ this.isPrepaidGift }" @change="${ (e) => this.isPrepaidGift = !this.isPrepaidGift }">
            <span class="skio-prepaid-slider round"></span>
          </label>

          Gift this subscription
        </div>
        
        <div class="skio-gift-prepaid-content ${ this.isPrepaidGift ? 'open' : ''}">
          <div class="skio-prepaid-input">
            <label for="prepaidGiftEmail">Gift Recipient Email</label>
            <input type="email" placeholder="recipient@email.com" @input="${(e) => this.email = e.target.value}"/>
          </div>

          <div class="skio-prepaid-input">
            <label for="prepaidGiftMessage">Message (optional)</label>
            <textarea placeholder="Enter your gift message" @input="${(e) => this.message = e.target.value}"></textarea>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('skio-prepaid-gift', SkioPrepaidGift)